import {
    Table,
    Badge,
    Button,
    ButtonGroup,
} from 'react-bootstrap';

const DirectionBadge = ({ direction }) => {
    if (!direction || direction === 'both') return <Badge style={{ backgroundColor: '#6f42c1' }}>Both</Badge>;
    if (direction === 'bullish') return <Badge bg="success">Bullish</Badge>;
    if (direction === 'bearish') return <Badge bg="danger">Bearish</Badge>;
    return null;
};

const TypeDisplay = ({ zone, isMergedPOI }) => {
    if (zone.isPOI || isMergedPOI) {
        return <Badge bg="secondary">POI</Badge>;
    }
    if (zone.type === 'supply') {
        return <Badge bg="danger">Supply Zone</Badge>;
    }
    if (zone.type === 'demand') {
        return <Badge bg="success">Demand Zone</Badge>;
    }
    return <span>{zone.type}</span>;
};

// Merge paired POI-both zones (same poiBothGroupId) into a single display row
const getMergedZones = (tradingZones) => {
    if (!tradingZones) return [];
    const seen = new Set();
    const result = [];
    for (const zone of tradingZones) {
        if (zone.poiBothGroupId) {
            if (seen.has(zone.poiBothGroupId)) continue;
            seen.add(zone.poiBothGroupId);
            result.push({ ...zone, direction: 'both', _isMergedPOI: true });
        } else {
            result.push(zone);
        }
    }
    return result;
};

export const TradingZonesTable = ({
    tradingZones,
    handleEditZone,
    handleDeleteZone,
}) => {
    const displayZones = getMergedZones(tradingZones);

    return (
        <div>
            {displayZones && displayZones.length > 0 &&
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th>Ticker</th>
                            <th>Type</th>
                            <th>Direction</th>
                            <th>Preset Zone</th>
                            <th>Price</th>
                            <th>Time Window</th>
                            <th>Label</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {displayZones.map(zone => {
                            return (
                                <tr key={zone.id}>
                                    <td>{zone.ticker}</td>
                                    <td><TypeDisplay zone={zone} isMergedPOI={zone._isMergedPOI} /></td>
                                    <td><DirectionBadge direction={zone.direction} /></td>
                                    <td>{zone.displayText}</td>
                                    <td>{(zone.isPOI || zone._isMergedPOI) ? zone.poiPrice : `${zone.min} - ${zone.max}`}</td>
                                    <td>{`${zone.startTime.toString()} - ${zone.endTime.toString()}`}</td>
                                    <td>{zone.label}</td>
                                    <td>
                                            <ButtonGroup size="sm">
                                                <Button
                                                    size="sm"
                                                    variant="primary"
                                                    onClick={() => handleEditZone(zone)}>
                                                    Edit
                                                </Button>
                                                <Button
                                                    size="sm"
                                                    variant="secondary"
                                                    onClick={() => handleDeleteZone(zone)}>
                                                    Delete
                                                </Button>
                                            </ButtonGroup>
                                    </td>
                                </tr>
                            );
                        })
                        }
                    </tbody>
                </Table>
            }
        </div>
    )
}
